import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#0A0C0F] pt-16 pb-28 md:pb-16" data-testid="site-footer">
      <div className="md-container grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center justify-center rounded-xl bg-white px-3 py-2">
              <img src="/myyntidrive-logo.png?v=7" srcSet="/myyntidrive-logo.png?v=7 1x, /myyntidrive-logo@2x.png?v=7 2x" alt="MyyntiDrive" className="h-10 w-auto block" width="217" height="128" />
            </span>
          </div>
          <p className="text-sm text-white/50 max-w-xs">
            MyyntiDrive Oy – ammattimaiset verkkosivut yritykselle alk. 150 € + alv 25,5 %. Näet mallisivut ennen kuin maksat euroakaan.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Palvelut</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/palvelut/verkkosivut" className="hover:text-white">Verkkosivut yritykselle</Link></li>
            <li><a href="/#palvelut" className="hover:text-white">Hinnastot</a></li>
            <li><a href="/#referenssit" className="hover:text-white">Referenssit</a></li>
            <li><a href="/#ukk" className="hover:text-white">UKK</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Yhteys</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li className="flex items-center gap-2"><Mail size={14} className="text-[#00E5FF]" /> <a href="mailto:info@myyntidrive.fi" className="hover:text-white">info@myyntidrive.fi</a></li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-[#00E5FF]" /> <a href="tel:+358505531110" className="hover:text-white">+358 50 553 1110</a></li>
            <li className="flex items-center gap-2"><MapPin size={14} className="text-[#00E5FF]" /> Palvelemme koko Suomessa</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Yritys</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li>MyyntiDrive Oy</li>
            <li>Y-tunnus: 3645516-2</li>
            <li><Link to="/tietosuoja" className="hover:text-white" data-testid="footer-privacy-link">Tietosuojaseloste</Link></li>
          </ul>
        </div>
      </div>
      <div className="md-container mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between text-xs text-white/40 gap-2">
        <p>© {new Date().getFullYear()} MyyntiDrive Oy. Kaikki oikeudet pidätetään.</p>
        <p>Palvelemme koko Suomessa</p>
      </div>
    </footer>
  );
}
